let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("fSodV")]).then(() => parcelRequire('dYpVn'));